/**
 * Wrapper div that collapses itself when it has no visible children.
 *
 * Uses a raw `<div>` — not a React Native `<View>` — so the CSS module
 * `className` is not overwritten by react-native-web. The CSS class applies
 * `display:none` via the `:empty` pseudo-selector, eliminating phantom spacing
 * when all children render `null`.
 */
import collapseStyles from './collapse-box.module.css';

// Raw div that hides itself via CSS :empty when no children produce DOM
// elements. Uses a <div> instead of <View> so the className isn't overwritten
// by react-native-web.
export function CollapseBox({ children, style, testID }: { children: React.ReactNode; style?: React.CSSProperties; testID?: string }) {
    return (
        <div className={collapseStyles.collapse} data-testid={testID} style={style}>
            {children}
        </div>
    );
}
